<script>
  import { DataTable } from "carbon-components-svelte";
  import GroupCell from "./components/GroupCell.svelte";
  import EditIcon from "./svg/EditIcon.svelte";
  import RemoveIcon from "./svg/RemoveIcon.svelte";
  import SearchInput from "./components/SearchInput.svelte";

  import Header from "../../../lib/components/Header.svelte";
  import Button from "../../../lib/components/Button.svelte";

  let rows = [
    {
      id: "a",
      name: "John Doe",
      version: 1.3,
      group: ["Group 1", "Group 2", "Group 3"],
      processowner: "John Doe",
      edit: "-",
      remove: "-",
    },
    {
      id: "aq",
      name: "John Doe",
      version: 1.3,
      group: ["Group 1", "Group 2"],
      processowner: "John Doe",
      edit: "-",
      remove: "-",
    },
    {
      id: "aw",
      name: "John Doe",
      version: 1.3,
      group: ["Group 1", "Group 2", "Group 3"],
      processowner: "John Doe",
      edit: "-",
      remove: "-",
    },
    {
      id: "ae",
      name: "John Doe",
      version: 1.3,
      group: ["Group 1"],
      processowner: "John Doe",
      edit: "-",
      remove: "-",
    },
    {
      id: "ar",
      name: "John Doe",
      version: 1.3,
      group: ["Group 2", "Group 3"],
      processowner: "John Doe",
      edit: "-",
      remove: "-",
    },
  ];

  let headers = [
    { key: "name", value: "Name" },
    { key: "version", value: "Version" },
    { key: "group", value: "Group" },
    { key: "processowner", value: "Process Owner" },
    { key: "edit", value: "Edit" },
    { key: "remove", value: "Remove" },
  ];

  const onEdit = (row, cell) => {
    console.log("onEdit", row, cell);
  };
  const onRemove = (row, cell) => {
    console.log("onRemove", row, cell);
  };

  const onGroupEdit = (row, cell, group) => {
    console.log("onGroupEdit", row, cell, group);
  };

  const onSearch = (value) => {
    console.log("onSearch", value);
  };
</script>

<Header section="Process Manager" breadcrumb="Process Management">
  <SearchInput on:search={onSearch} />

  <!-- @Adrian hier keine Funktion in den Buttons (waren nur Platzhalter)-->

  <Button
    variant="secondary"
    setting={true}
    iconLeft={true}
    text="New Group"
    icon="add"
  />
  <Button
    variant="secondary"
    setting={true}
    iconLeft={true}
    text="Add Process"
    icon="add"
  />
  <Button
    variant="secondary"
    setting={true}
    iconLeft={true}
    text="Back"
    icon="arrow_left"
  />
</Header>

<section>
  <div class="header">
    <h1>PROCESSES</h1>
    <div>
      <span>15 Processes</span>
    </div>
  </div>
  <div>
    <DataTable {headers} {rows} class="custom-table">
      <svelte:fragment slot="cell" let:row let:cell>
        {#if cell.key === "group"}
          <GroupCell {row} {cell} {onGroupEdit} />
        {:else if cell.key === "edit"}
          <button on:click={() => onEdit(row, cell)} class="edit-remove-btn"
            ><EditIcon /></button
          >
        {:else if cell.key === "remove"}
          <button on:click={() => onRemove(row, cell)} class="edit-remove-btn"
            ><RemoveIcon /></button
          >
        {:else}
          {cell.value}
        {/if}
      </svelte:fragment>
    </DataTable>
  </div>
</section>

<style>
  section {
    background: var(--pax-smoke);
    width: 100%;
    height: 100%;
    padding: 12px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px;
  }
  .header h1 {
    overflow: hidden;
    color: var(--pax-black);
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .header > div {
    display: flex;
    gap: 12px;
  }

  .header > div > span {
    border-radius: 5px;
    background: var(--pax-white);
    padding: 18px 10px;
    color: var(--pax-black);
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
  }

  .edit-remove-btn {
    background: var(--pax-black);
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: grid;
    place-items: center;
  }

  :global(.cross-plus-icon) {
    rotate: 45deg;
  }
</style>
